import {TruckConfiguration} from '../../../../fields'
import {BuildConfigurationInput} from '../../../../types'
import {OrderDto} from '../../../types'

import {getOrderTruckMaxLoad, getDefaultTruckSize} from './trucks.utils'

/**
 * Builds truck configuration for order management with custom settings.
 * Truck selector is always disabled and default size is taken from the order's maxLoadSize.
 * Falls back to constraints.trucks.defaultTruckSize if order has no truck configuration.
 *
 * @param order - Order data containing delivery schedule with truck configuration
 * @param input - Build configuration input containing options and constraints
 * @returns Truck configuration with disabled selector and order-specific default size
 */
export const buildTruckConfiguration = (
  order: OrderDto,
  {options: {constraints}}: BuildConfigurationInput
): TruckConfiguration => {
  const truckMaxLoad = getOrderTruckMaxLoad(order) || getDefaultTruckSize(constraints.trucks)
  return {
    trucks: {
      // always disabled for order management
      isEnabled: false,
      defaultTruckSize: truckMaxLoad
    }
  }
}
